<template>
  <div class="row">
    <clip-loader :loading="fetchingData" :color="'#000'"></clip-loader>
    <div v-if="!fetchingData">
      <Document v-for="(document, index) in requiredDocuments"
        :document="document"
        :key="index"
        @document:created="documentCreated($event, index)"
        @document:submitted="documentSubmitted($event, index)">
      </Document>
    </div>
  </div>
</template>

<script>
import Document from '@/components/Organization/Document';
import organizationsApi from '@/api/v1/organizations';
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
  components: { Document, ClipLoader },
  props: { organization: Object },
  data() {
    return {
      requiredDocuments: [
        {
          Type: 'IDENTITY_PROOF',
          Id: this.organization.identity_proof_id,
          Status: '',
          RefusedReasonType: '',
          RefusedReasonMessage: '',
        },
        {
          Type: 'ARTICLES_OF_ASSOCIATION',
          Id: this.organization.articles_of_association_id,
          Status: '',
          RefusedReasonType: '',
          RefusedReasonMessage: '',
        },
        {
          Type: 'REGISTRATION_PROOF',
          Id: this.organization.registration_proof_id,
          Status: '',
          RefusedReasonType: '',
          RefusedReasonMessage: '',
        },
        {
          Type: 'SHAREHOLDER_DECLARATION',
          Id: this.organization.shareholder_declaration_id,
          Status: '',
          RefusedReasonType: '',
          RefusedReasonMessage: '',
        },
      ],
      fetchingData: true,
    };
  },
  methods: {
    documentCreated(document, index) {
      this.$set(this.requiredDocuments, index, document);
      this.$emit('document:created', document);
    },
    documentSubmitted(document, index) {
      this.$set(this.requiredDocuments, index, document);
    },
  },
  created() {
    organizationsApi.listDocuments((response) => {
      const missingDocs = this.requiredDocuments.filter(requiredDoc => !requiredDoc.Id);
      this.requiredDocuments = [...response.documents, ...missingDocs];
      this.fetchingData = false;
    });
  },
};
</script>



// WEBPACK FOOTER //
// Documents.vue?56a292a7